// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.premium-plan-detail {
    width: 24%;
    border-radius: 10px;
}

.plan-detail:hover {
    cursor: pointer;
    box-shadow: 0 4px 50px rgba(0, 0, 0, 0.25);
}

.plan-detail-header {
    height: 170px;
    display: flex;
    padding: 5px 20px;
    background: #F5F5F5;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.current-plan-tag {
    width: 35%;
    display: flex;
    margin: 20px 0;
    border-radius: 50px;
    justify-content: center;
    border: 1px solid #FFFFFF;
    background-color: transparent;
}

.current-plan-tag img {
    width: 20px;
}

.plan-detail-header h3 {
    margin: 10px 0;
    color: #004BA0;
    font-size: 24px;
}

.plan-detail-header span {
    color: #004BA0;
    font-size: 20px;
    font-weight: bold;
}

.current-plan-tag span {
    margin: 5px 0;
    font-size: 10px;
    color: #FFFFFF;
}

.detail-row {
    height: 150px;
    margin: 0 10px;
    display: flex;
    flex-flow: column;
    text-align: center;
    justify-content: center;
    border-bottom: 0.5px solid #BDBDBD;
}

.detail-row span {
    color: #424242;
    font-size: 20px;
}

.tick-cross-image {
    width: 25px;
    height: 25px;
    margin: 0 auto;
    text-align: center;
}

.tick-cross-image img {
    width: 100%;
    height: 100%;
}

@media only screen and (max-width: 600px) {
    .premium-plan-detail {
        width: 95%;
        margin-top: 20px;
        text-align: center;
    }

    .plan-detail-header {
        border-bottom: 0.5px solid #BDBDBD;
    }

    .plan-detail-header h3 {
        font-size: 26px;
    }

    .plan-detail-header span {
        font-size: 24px;
    }

    .tick-cross-image {
        width: 25px;
        height: 25px;
        margin: 0 10px;
    }

    .tick-cross-image img {
        width: 100%;
    }

    .detail-row {
        height: 40px;
        display: flex;
        flex-direction: row;
        border-bottom: none;
        align-items: center;
        justify-content: start;
    }

    .detail-row span {
        font-size: 16px;
    }

    .current-plan-tag span {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/premium-plan-detail.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".premium-plan-detail {\n    width: 24%;\n    border-radius: 10px;\n}\n\n.plan-detail:hover {\n    cursor: pointer;\n    box-shadow: 0 4px 50px rgba(0, 0, 0, 0.25);\n}\n\n.plan-detail-header {\n    height: 170px;\n    display: flex;\n    padding: 5px 20px;\n    background: #F5F5F5;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.current-plan-tag {\n    width: 35%;\n    display: flex;\n    margin: 20px 0;\n    border-radius: 50px;\n    justify-content: center;\n    border: 1px solid #FFFFFF;\n    background-color: transparent;\n}\n\n.current-plan-tag img {\n    width: 20px;\n}\n\n.plan-detail-header h3 {\n    margin: 10px 0;\n    color: #004BA0;\n    font-size: 24px;\n}\n\n.plan-detail-header span {\n    color: #004BA0;\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.current-plan-tag span {\n    margin: 5px 0;\n    font-size: 10px;\n    color: #FFFFFF;\n}\n\n.detail-row {\n    height: 150px;\n    margin: 0 10px;\n    display: flex;\n    flex-flow: column;\n    text-align: center;\n    justify-content: center;\n    border-bottom: 0.5px solid #BDBDBD;\n}\n\n.detail-row span {\n    color: #424242;\n    font-size: 20px;\n}\n\n.tick-cross-image {\n    width: 25px;\n    height: 25px;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.tick-cross-image img {\n    width: 100%;\n    height: 100%;\n}\n\n@media only screen and (max-width: 600px) {\n    .premium-plan-detail {\n        width: 95%;\n        margin-top: 20px;\n        text-align: center;\n    }\n\n    .plan-detail-header {\n        border-bottom: 0.5px solid #BDBDBD;\n    }\n\n    .plan-detail-header h3 {\n        font-size: 26px;\n    }\n\n    .plan-detail-header span {\n        font-size: 24px;\n    }\n\n    .tick-cross-image {\n        width: 25px;\n        height: 25px;\n        margin: 0 10px;\n    }\n\n    .tick-cross-image img {\n        width: 100%;\n    }\n\n    .detail-row {\n        height: 40px;\n        display: flex;\n        flex-direction: row;\n        border-bottom: none;\n        align-items: center;\n        justify-content: start;\n    }\n\n    .detail-row span {\n        font-size: 16px;\n    }\n\n    .current-plan-tag span {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
